module.exports = __webpack_public_path__ + "img/company-honor-TPD-20230721.89824adb.jpg";